import { productConstants } from '../constants';

export function products(state = {}, action) {
  switch (action.type) {
    case productConstants.GETALL_REQUEST:
      return {
        state,
        loading: true
      }
    case productConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        last_page: action.last_page,
        loading: false
      }
    case productConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      }
    default:
      return state;
  }
}

export function product(state = {}, action) {
  switch (action.type) {
    case productConstants.GET_REQUEST:
      return {
        state,
        loading: true
      }
    case productConstants.GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false
      }
    case productConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}

export function AddProduct(state = {}, action) {
  switch (action.type) {
    case productConstants.ADD_REQUEST:
      return {
        state,
        loading: true
      }
    case productConstants.ADD_SUCCESS:
      return {
        ...state,
        response: action.response,
        loading: false
      }
    case productConstants.ADD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}

export function EditProduct(state = {}, action) {
  switch (action.type) {
    case productConstants.EDIT_REQUEST:
      return {
        state,
        loading: true
      }
    case productConstants.EDIT_SUCCESS:
      return {
        ...state,
        response: action.response,
        loading: false
      }
    case productConstants.EDIT_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}
